<app-table
  *ngIf="cols && dropdownFilters"
  [cols]="cols"
  pageFunctionName="getProductErrorsList"
  [service]="productErrorsService"
  modelName="erros de produtos"
  sortField="createdAt"
  [sortOrder]="-1"
  [defaultRows]="10"
  [changeColumns]="true"
  [addButton]="false"
  [dropdownFilters]="dropdownFilters"
/>
<p-toast />
